module.exports = __webpack_public_path__ + "static/media/blue-cloud.2f67e2be.svg";